import * as React from 'react';

export interface ItemsPerPageProps {
    /**
     * The items per page
     */
    itemsPerPage: number;
    /**
     * Function to invoke on change
     */
    onItemsPerPageChange: (itemsPerPage: number) => void;
}

export interface ItemsPerPageState {
    /**
     * The current value of the input
     */
    itemsPerPage: '' | number;
}

/**
 * This is the ItemsPerPage component
 */
export class ItemsPerPage extends React.Component<
    ItemsPerPageProps,
    ItemsPerPageState
> {
    constructor(props: ItemsPerPageProps) {
        super(props);
        this.state = { itemsPerPage: props.itemsPerPage };
    }

    /**
     * Called when the props are updated, update the component state
     * @param nextProps New props
     */
    componentWillReceiveProps(nextProps: ItemsPerPageProps) {
        this.setState({ itemsPerPage: nextProps.itemsPerPage });
    }

    render() {
        return (
            <div className="dataTables_length pull-left">
                Show{' '}
                <input
                    type="text"
                    value={this.state.itemsPerPage}
                    onChange={event => this.handleChange(event)}
                    onBlur={event => this.handleBlur(event)}
                    onKeyPress={event => this.handleKeyPress(event)}
                />{' '}
                entries
            </div>
        );
    }

    /**
     * Change the items per page
     * @param itemsPerPage New items per page
     */
    private changeItemsPerPage(itemsPerPage: number) {
        const validItemsPerPage = this.getValidItemsPerPage(itemsPerPage);
        this.setState({ itemsPerPage: validItemsPerPage });

        if (this.props.itemsPerPage !== validItemsPerPage) {
            this.props.onItemsPerPageChange(validItemsPerPage);
        }
    }

    /**
     * Get a valid items per page to change to
     * @param itemsPerPage The items per page we're attempting to change to
     */
    private getValidItemsPerPage(itemsPerPage: number) {
        let validItemsPerPage = itemsPerPage;
        if (isNaN(itemsPerPage)) {
            validItemsPerPage = this.props.itemsPerPage;
        }
        return validItemsPerPage >= 1 && validItemsPerPage <= 1000
            ? validItemsPerPage
            : 15;
    }

    /**
     * Handles the items per page input changing
     * @param event The change event
     */
    private handleChange(event: React.ChangeEvent<HTMLInputElement>) {
        const value = event.target.value;

        if (value === '') {
            this.setState({ itemsPerPage: value });
        } else {
            this.setState({
                itemsPerPage: this.getValidItemsPerPage(Number(value))
            });
        }
    }

    /**
     * Handles the input losing focus, actually updates the master state
     * @param event The focus event
     */
    private handleBlur(event?: React.FocusEvent<HTMLInputElement>) {
        if (event) {
            event.preventDefault();
        }

        this.changeItemsPerPage(
            this.state.itemsPerPage === ''
                ? this.props.itemsPerPage
                : this.state.itemsPerPage
        );
    }

    /**
     * Handles key presses, invoking a master state change if enter is pressed
     * @param event Key event
     */
    private handleKeyPress(event: React.KeyboardEvent<HTMLInputElement>) {
        if (event.key.toLowerCase() === 'enter' || event.keyCode === 13) {
            this.handleBlur();
        }
    }
}
